import { CaptureState, VIDEO_SIZES_TYPE } from './type';

export const VIDEO_SIZES: VIDEO_SIZES_TYPE[] = [
  { 'label': '4K (UHD)', 'width': 3840, 'height': 2160 },
  { 'label': '1080p (FHD)', 'width': 1920, 'height': 1080 },
  { 'label': 'UXGA', 'width': 1600, 'height': 1200 },
  { 'label': '720p (HD)', 'width': 1280, 'height': 720 },
  { 'label': 'SVGA', 'width': 800, 'height': 600 },
  { 'label': '480p (VGA)', 'width': 640, 'height': 480 },
  { 'label': '360p (nHD)', 'width': 640, 'height': 360 },
  /* { 'label': 'CIF', 'width': 352, 'height': 288 },
  { 'label': 'QVGA', 'width': 320, 'height': 240 },
  { 'label': 'QCIF', 'width': 176, 'height': 144 },
  { 'label': 'QQVGA', 'width': 160, 'height': 120 }, */
];
export const initialState: CaptureState = {
  resolutionList: VIDEO_SIZES,
  cameraList: [],
  micList: [],
  selectedVideo: '',
  selectedMic: '',
  selectedResolution: VIDEO_SIZES[3],
  mediaRecorder: null,
  enableMic: false,
  shortcut: {
    snapshot: 'alt + c',
    record: 'alt + r',
    fullscreen: 'alt + Enter',
    pause: 'alt + p',
  },
  isGranted: false,
  recordStream: undefined,

  elapsedTime: 0,
  intervalId: null,
  isFullScreen: false,
};

export const DefaultInputDevice = ['AVerMedia SD Analog Capture'];
export const DefaultOutputDevice = ['AV TO USB2.0', 'OBS Virtual Camera'];
export const KEY_DEFAULT_CAMERA = 'DEFAULT_CAMERA';
